import { useState } from "react";

export const useFormInput = (initialValues) => {
  const [values, setValues] = useState(initialValues);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleDateChange = (name, date) => {
    setValues((prevValues) => ({
      ...prevValues,
      [name]: date ? date.toDate() : null, // Convert dayjs object to Date
    }));
  };

  const resetForm = () => {
    setValues(initialValues);
  };

  return {
    values,
    handleChange,
    handleDateChange,
    setValues, // Allow setting values directly if needed
    resetForm,
  };
};
